import { getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

import { ICONS_MAP } from 'constants/icons';

import Typography from '../Typography';

const prefix = ['components', 'noItemsFound'];

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 0 auto;
  max-width: 270px;
  word-break: break-word;
`;

export const Title = styled(Typography)`
  color: ${getPrefixedVar(prefix, 'title')};
  margin: 20px 0 0;
`;

export const Subtitle = styled(Typography)`
  color: ${getPrefixedVar(prefix, 'message')};
  margin-top: 8px;
`;

export const ButtonContainer = styled.div`
  margin-top: 40px;
`;

export const StyledIcon = styled(ICONS_MAP.EmptySearch)`
  .dot {
    fill: ${getPrefixedVar(prefix, 'icon', 'dot')};
  }

  .searchCircle {
    fill: ${getPrefixedVar(prefix, 'icon', 'searchCircle')};
  }

  .search {
    stroke: ${getPrefixedVar(prefix, 'icon', 'search')};
  }

  .cloud {
    fill: ${getPrefixedVar(prefix, 'icon', 'cloud')};
  }

  .bgCircle {
    fill: ${getPrefixedVar(prefix, 'icon', 'bgCircle')};
  }
`;
